import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterIdSearchValueObject} from './FilterIdSearchValueObject.js'

export class FilterEntrySearchValueObject extends ValueObject {
  #entry

  constructor({entry}) {
    super()
    this.#entry = entry
  }

  static create({entry}) {
    return new FilterEntrySearchValueObject({entry: FilterIdSearchValueObject.create(entry)})
  }

  static createWithDefaultValue({config, entry}) {
    const {DEFAULT_FINANCING_ENTRY_SEARCH} = config.get('searchFilters')

    return new FilterEntrySearchValueObject({
      entry: FilterIdSearchValueObject.create({id: entry ?? DEFAULT_FINANCING_ENTRY_SEARCH})
    })
  }

  static createQueryParams({config, entry}) {
    const {DEFAULT_FINANCING_ENTRY_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterEntrySearchValueObject({
      entry: QueryParamSharedValueObject.createForSingle({
        key: FILTER_QUERY_PARAMS[FILTER_NAMES.FINANCING_ENTRY],
        value: entry || DEFAULT_FINANCING_ENTRY_SEARCH
      })
    })
  }

  get isEmpty() {
    return this.#entry.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.isEmpty && {...this.#entry.queryParam})
    }
  }

  get value() {
    return this.#entry.value
  }

  toJSON() {
    return {
      entry: this.#entry.toJSON()
    }
  }
}
